module.exports = __webpack_public_path__ + "images/114_2048.jpg";